import { Directive, HostBinding, Input, OnInit, OnDestroy, ElementRef } from '@angular/core';

import { AsLinkDirective } from '../as-link/as-link.directive';

import { fromEvent, merge, filter, Subscription, Observable } from 'rxjs';

@Directive({
  selector: '[as-button]'
})
export class AsButtonDirective extends AsLinkDirective implements OnInit, OnDestroy {
  @Input() disabled: boolean = false;

  private subscriptions: Subscription = new Subscription();

  constructor(private element: ElementRef) {
    super();
  }

  @HostBinding('attr.role') override role: string = 'button';
  @HostBinding('attr.tabindex') get tabIndex(): string {
    return this.disabled ? '-1' : '0';
  }
  @HostBinding('attr.aria-disabled') get ariaDisabled(): string | undefined {
    return this.disabled ? 'true' : undefined;
  }

  ngOnInit(): void {
    this.subscriptions.add(
      merge(
        fromEvent<MouseEvent>(this.element.nativeElement, 'click', {
          capture: true
        }),
        fromEvent<KeyboardEvent>(this.element.nativeElement, 'keydown', {
          capture: true
        })
      )
        .pipe(
          filter(
            (e: MouseEvent | KeyboardEvent) =>
              !(e instanceof KeyboardEvent) || e.key === 'Enter' || e.key === ' '
          )
        )
        .subscribe((event: any) => {
          if (!this.disabled) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          event.stopPropagation();
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
